module.exports = "pegasus_template/assets/spectrum.png";